class SettingsService {
    get apiUrl() {
        return process.env.VUE_APP_API_URL;
    }

    get idsrvUrl() {
        return process.env.VUE_APP_IDENTITY;
    }

    get callbackUrl() {
        return process.env.VUE_APP_CALLBACK;
    }

    get travellaMenuScriptUrl() {
        return process.env.VUE_APP_TRAVELLA_MENU_URL;
    }

    get isDevelopmentMode() {
        return process.env.NODE_ENV === "development";
    }

    get hotOfertaApi() {
        return process.env.VUE_APP_HOT_OFERTA;
    }

    get mojeGreckieWakacje() {
        return process.env.VUE_APP_GRECKIE_WAKACJE;
    }

    get wakacyjny() {
        return process.env.VUE_APP_BEST_PROMOCJA;
    }

    get bestseller() {
        return process.env.VUE_APP_BESTSELLER;
    }

    get lecZaDarmoApi() {
        return process.env.VUE_APP_LEC_ZA_DARMO;
    }

    get profile() {
        return process.env.VUE_APP_USER_PROFILE;
    }

    get env() {
        return process.env.VUE_APP_ENV;
    }
}

const settingsService = new SettingsService();
export default settingsService;
